export const COMMON_LOTTIE_ASSETS = {
    NEW_BADGE_LOTTIE_FILE_ID: "v1676902816/newBadge_qyb4os.json",
    TRANSITION_LOTTIE_FILE_ID: "portal/m/cw_transition_screen_v2/transition_loader.json",
};

export const LOTTIE_ASSETS = {
    ...COMMON_LOTTIE_ASSETS,

    DE_TIP_LOTTIE_FILE_ID: "4_0_Assets/de_tip_lottie.json",
    DE_TIP_MAIN_PRE_TIP_FILE_ID: "portal/m/cw_de_tip_lottie/pre_tip_add_lottie.json",
    TRANSITION_LOTTIE_FILE_ID_BLACK: "BLCK/black_plan_transition_lottie_2.json",
    TRANSITION_LOTTIE_FILE_ID_BLACK_OTP: "portal/m/one_blck_assets/black_otp_transition_lottie_7.json",
    TRANSITION_LOTTIE_FILE_ID_POP: "Sunshine/Confirmation_screen_3.json",
    TRANSITION_LOTTIE_FILE_ID_BOLT: "portal/static-assets/hcms/bolt_confirmation_2.json",
    TRANSITION_LOTTIE_FILE_ID_BOLT_OTP: "portal/static-assets/hcms/bolt/black_with_otg.json",
    TRANSITION_LOTTIE_FILE_ID_AFFORDABLE: "portal/static-assets/hcms/order_placed_99_store_with_marker.json",
    // TODO:  chnage this uri to the correct one
    TOING_TRANSITION_LOTTIE_FILE_ID: "portal/static-assets/lotties/toing-confirmation6.json",
    TRANSITION_LOTTIE_FILE_ID_GIFTING_ORDER_PLACED:
        "portal/static-assets/lotties/gifting-cart/gifting_order_placed.json",
    FREEBIE_WIDGET_LOTTIE_FILE_ID: "portal/static-assets/lotties/snacc_freebie_widget_lottie_new.json",

    // SPLASH_LOTTIES
    NINETY_NINE_STORE_SPLASH_LOTTIE: "portal/static-assets/lotties/99STORE_Cart_offer_v1.09.json",

    // Toing Price Comparison Lotties
    WINNING_STATE_LOTTIE_FILE_ID:
        "Lotties%20-%20srushti/Toing/Shruti%20Toing/Final%20states/winning%20success%20state.json",
    LOST_DARE_STATE_LOTTIE_FILE_ID:
        "Lotties%20-%20srushti/Toing/Shruti%20Toing/Final%20states/Lost%20state%20updated2.json",
    TUTORIAL_STATE_LOTTIE_FILE_ID: "TOING%20DARE%202%20COMPARE/Animation/updatedcopiesU.json",
    TIE_WITH_SAVINGS_LOTTIE_FILE_ID:
        "Lotties%20-%20srushti/Toing/Shruti%20Toing/Final%20states/Tie%20with%20Savings%20updated2.json",
    TIE_WITHOUT_SAVINGS_LOTTIE_FILE_ID:
        "Lotties%20-%20srushti/Toing/Shruti%20Toing/Final%20states/Tie%20without%20savings.json",
    SCANNING_STATE_LOTTIE_FILE_ID: "TOING%20DARE%202%20COMPARE/Animation/newscanning.json",
    DELIVERY_MODE_ANIMATION_ASSET_ID: "toing_aditya/toing-quick-del-mode-v1.02.json",
};

export const IXIGO_LOTTIE_ASSETS = { ...COMMON_LOTTIE_ASSETS };

export const SOUND_ASSETS = {
    TRING_SOUND: "portal/m/one_blck_assets/tring_sound_1.mp3",
    SPEEDY_SOUND: "portal/static-assets/hcms/bolt/zoop.mp3",
    TOING_SOUND: "Toing/Sound/Toing-14.mp3",
};

export const FESTIVE_LOTTIE_ASSETS = {
    FESTIVE_DE_TIP_LOTTIE_FILE_ID: "portal/static-assets/hcms/testing/RD_tip_added_1.json",
    FESTIVE_DE_TIP_MAIN_PRE_TIP_FILE_ID: "portal/static-assets/hcms/tipping/RD_struggles_tipping.json",
    FESTIVE_TRANSITION_LOTTIE_FILE_ID: "portal/static-assets/hcms/testing/RD_OP_1.json?v=1",
};

export const FESTIVE_START_DATE = new Date("2025-01-26T00:00:00Z");
export const FESTIVE_END_DATE = new Date("2025-01-27T00:00:00Z");
export const FESTIVE_LOTTIE_IMAGES_ASSET_PATH = "portal/static-assets/hcms/tipping/images/img_{0}.png";
export const FESTIVE_LOTTIE_IMAGES_ASSET_COUNT = 3;

export const HEADER_LOTTIE_ASSETS = {
    EXPRESS_TRANSITION: "portal/static-assets/hcms/cart-header/cart_header_express.json",
    NON_EXPRESS_TRANSITION: "portal/static-assets/hcms/cart-header/cart_non_express_header.json",
    OTG_STAMP: "portal/static-assets/hcms/cart_otg_stamp_lottie_container_v2.json",
    BOLT_TRANSITION: "portal/static-assets/hcms/bolt_header_new.json",
    BOLT_SLA_10_STAMP: "portal/static-assets/hcms/bolt/10_min_stamp_new.json",
    BOLT_SLA_15_STAMP: "portal/static-assets/hcms/bolt/15_min_stamp_new.json",
    BOLT_OTG_STAMP: "portal/static-assets/hcms/bolt/otg_stamp_1.json",
    BOLT_RANGE_SLA_TRANSITION: "portal/static-assets/hcms/bolt/bolt_lightning_fast_sla_range.json",
    BOLT_RANGE_SLA_STAMP: "portal/static-assets/hcms/bolt/bolt_sla_range_stamp.json",
    EO_CART_HEADER_ONE: "Food_EO/cart_header-one_eo_v5.json",
    _99STORE_HEADER_LOTTIE: "portal/static-assets/hcms/99StoreCartHeaderz.json",
};

export const CROSS_SELL_LOTTIE_ASSETS = {
    EO_LOCKED_ONE: "Food_EO/cross%20sell%20ONE%20EO%20V5.json",
    EO_LOCKED_ONE_BLACK: "Food_EO/cross%20sell%20BLCK%20EO%20V5.json",
};
